import { atom } from "jotai";
import type { Currency } from "../types";
import { coerceSupportedCurrency, DEFAULT_APP_CURRENCY } from "../lib/currency";

export const CURRENT_CURRENCY_STORAGE_KEY = "current_currency";

function readStoredCurrency(): Currency {
  if (typeof window === "undefined") return DEFAULT_APP_CURRENCY;
  const stored = window.localStorage.getItem(CURRENT_CURRENCY_STORAGE_KEY);
  return coerceSupportedCurrency(stored);
}

const baseCurrencyAtom = atom<Currency>(readStoredCurrency());

export const currentCurrencyAtom = atom(
  (get) => get(baseCurrencyAtom),
  (_get, set, next: Currency) => {
    const normalized = coerceSupportedCurrency(next);
    set(baseCurrencyAtom, normalized);
    if (typeof window !== "undefined") {
      window.localStorage.setItem(CURRENT_CURRENCY_STORAGE_KEY, normalized);
    }
  },
);
